import React from "react";
import {
    Stack, TextField, FormControl, InputLabel, Select,
    MenuItem, Box, Button, Typography,
    ButtonGroup,
    IconButton,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import { FormatAlignLeft, FormatAlignCenter, FormatAlignRight } from "@mui/icons-material";
import { COLOR_INPUT_STYLE, FONT_FAMILIES } from "../constants";
import PositionPanel from "./PositionPanel";

export default function TextPanel({ el, updateEl, mode = "design" }) {
    return (
        <Stack spacing={1.5}>
            <TextField
                label="Nom du champ"
                value={el.fieldName || ""}
                onChange={e => updateEl(el.id, { fieldName: e.target.value })}
                size="small"
                fullWidth
                helperText="Ex: titre, prix, sous_titre"
            />

            {mode === "model" && (
                <FormControlLabel
                    sx={{ mt: -0.5 }}
                    control={
                        <Checkbox
                            size="small"
                            checked={!!el.fixed}
                            onChange={e => updateEl(el.id, { fixed: e.target.checked })}
                        />
                    }
                    label={<Typography variant="body2">Fixe (non editable dans le formulaire design)</Typography>}
                />
            )}

            <TextField
                label="Contenu"
                value={el.text}
                onChange={e => updateEl(el.id, { text: e.target.value })}
                multiline
                size="small"
                fullWidth
            />

            <TextField
                label="Taille de police"
                type="number"
                size="small"
                value={el.fontSize}
                inputProps={{ min: 8, max: 400 }}
                onChange={e => updateEl(el.id, { fontSize: Number(e.target.value) })}
            />

            <FormControl size="small" fullWidth>
                <InputLabel>Police</InputLabel>
                <Select
                    value={el.fontFamily}
                    label="Police"
                    onChange={e => updateEl(el.id, { fontFamily: e.target.value })}
                >
                    {FONT_FAMILIES.map(f => (
                        <MenuItem key={f} value={f} style={{ fontFamily: f }}>{f}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            <ButtonGroup>
                <IconButton color={el.textAlign === "left" ? "primary" : "default"} onClick={() => updateEl(el.id, { textAlign: "left" })}>
                    <FormatAlignLeft/>
                </IconButton>
                <IconButton color={el.textAlign === "center" ? "primary" : "default"} onClick={() => updateEl(el.id, { textAlign: "center" })}>
                    <FormatAlignCenter/>
                </IconButton>
                <IconButton color={el.textAlign === "right" ? "primary" : "default"} onClick={() => updateEl(el.id, { textAlign: "right" })}>
                    <FormatAlignRight/>
                </IconButton>
            </ButtonGroup>

            <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                    size="small"
                    sx={{ fontWeight: "bold", minWidth: 40 }}
                    variant={el.fontWeight === "bold" ? "contained" : "outlined"}
                    onClick={() => updateEl(el.id, { fontWeight: el.fontWeight === "bold" ? "normal" : "bold" })}
                >
                    B
                </Button>
                <Button
                    size="small"
                    sx={{ fontStyle: "italic", minWidth: 40 }}
                    variant={el.fontStyle === "italic" ? "contained" : "outlined"}
                    onClick={() => updateEl(el.id, { fontStyle: el.fontStyle === "italic" ? "normal" : "italic" })}
                >
                    I
                </Button>
                <Button
                    size="small"
                    sx={{ textDecoration: "underline", minWidth: 40 }}
                    variant={el.textDecoration === "underline" ? "contained" : "outlined"}
                    onClick={() => updateEl(el.id, { textDecoration: el.textDecoration === "underline" ? "none" : "underline" })}
                >
                    U
                </Button>
                <Button
                    size="small"                    
                    sx={{ textDecoration: "line-through", minWidth: 40 }}
                    variant={el.textDecoration === "line-through" ? "contained" : "outlined"}
                    onClick={() => updateEl(el.id, { textDecoration: el.textDecoration === "line-through" ? "none" : "line-through" })}
                >
                    S
                </Button>
            </Box>

            <Box>
                <Typography variant="caption" color="text.secondary">Couleur du texte</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                    <input
                        type="color"
                        value={el.color}
                        onChange={e => updateEl(el.id, { color: e.target.value })}
                        style={COLOR_INPUT_STYLE}
                    />
                    <Typography variant="body2">{el.color}</Typography>
                </Box>
            </Box>

            <PositionPanel el={el} updateEl={updateEl} />
        </Stack>
    );
}
